import React, { Component } from 'react';
import { connect } from 'dva';
import SelectUser from 'nbugs-address-select-user';
import { Alert, Icon, Modal, Spin } from 'antd';
import styles from './index.less';

const { confirm } = Modal;

@connect(({ keyPost }) => {
  return {
    ...keyPost,
  };
})
class KeyPost extends Component {
  componentDidMount() {
    this.handleFetchData();
  }

  handleFetchData = () => {
    const { dispatch } = this.props;

    dispatch({
      type: 'keyPost/fetchKeyPost',
    });
  };

  handleChange = ({ status = false, checkedNodes = [], selectPostSign = '', ...other } = {}) => {
    const { dispatch } = this.props;

    dispatch({
      type: 'keyPost/save',
      payload: {
        selectUserVisible: status,
        checkedNodes,
        selectPostSign,
        ...other,
      },
    });
  };

  // 删除
  handleDel = ({ userId = '', deptId = '', userName = '' }, postSign = '') => {
    const { dispatch } = this.props;

    confirm({
      okText: '确认',
      cancelText: '取消',
      title: '删除岗位设置',
      content: `确定删除“${userName}”岗位设置？`,
      onOk: () => {
        dispatch({
          type: 'keyPost/fetchDeptRoleList',
          params: {
            userId,
            deptId,
            roleSign: postSign,
          },
        }).then(() => this.handleFetchData());
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  handleConfirm = ({ checkedNodes = [] }) => {
    const { dispatch, selectPostSign = '' } = this.props;
    const posts = (checkedNodes || [])
      .filter(nodes => nodes.type === 'user')
      .map(({ userId = '', deptId = '' }) => ({
        deptId,
        userId,
        postSign: selectPostSign,
      }));

    dispatch({
      type: 'keyPost/add',
      params: {
        posts,
      },
    }).then(() => this.handleFetchData());
  };

  // 渲染人员列表
  renderUser = (user, postSign) => {
    const { userId = '', userName = '', deptId = '', deptName = '' } = user;

    return (
      <div className="user-item" key={`${deptId}_${userId}`}>
        {userName}
        <span>[{deptName}]</span>
        <Icon type="close" onClick={() => this.handleDel(user, postSign)} />
      </div>
    );
  };

  // 渲染岗位列表
  renderPost = post => {
    const { postSign = '', postName = '', users } = post;

    return (
      <div className="key-positions-body-list-item" key={postSign}>
        <div className="positions-name">{postName}:</div>
        <div className="user-list">
          {users && users.map(user => this.renderUser(user, postSign))}
          <div
            className="btn"
            onClick={() =>
              this.handleChange({
                status: true,
                checkedNodes: users.map(user => {
                  const newUser = user;
                  newUser.type = 'user';
                  return newUser;
                }),
                selectPostSign: postSign,
              })
            }
          >
            {users && users.length > 0 ? '添加' : '设置'}
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { posts, selectUserVisible, checkedNodes, spinProps } = this.props;

    return (
      <div className={styles['key-positions-wrap']}>
        <Spin {...spinProps}>
          <Alert
            message="使用说明"
            description="请根据实际情况进行关键岗位设置，岗位设置后会影响到教育局的通知、公文、会议等信息的接收"
            type="info"
          />
          <div className="key-positions-body">
            <div className="key-positions-body-title">关键岗位设置</div>
            <div className="key-positions-body-list-wrap">
              <div className="key-positions-body-list">
                {posts && posts.map(post => this.renderPost(post))}
              </div>
            </div>
          </div>
          {selectUserVisible && (
            <SelectUser
              loopStyle="entire"
              selectType="user"
              showComp
              checkedNodes={checkedNodes}
              onCancel={this.handleChange}
              onOk={this.handleConfirm}
              deptNodeCheckable={false}
              showSearchInput={false}
            />
          )}{' '}
        </Spin>
      </div>
    );
  }
}
export default KeyPost;
